<template>
  <!-- 搜索记录的 单选用户，滚动到底部分页加载数据 -->
  <div>
    <div
      class="user-list"
      infinite-scroll-immediate-check="false"
      v-infinite-scroll="handleInfiniteOnLoad"
      :infinite-scroll-disabled="busy"
      :infinite-scroll-distance="0"
    >
      <a-list itemLayout="horizontal" :loading="loading" :dataSource="userList">
        <a-list-item class="member-list-item" slot="renderItem" slot-scope="item" @click.stop="handleChoose(item)">
          <span slot="actions">
            <a-icon type="check" v-show="listTemp.id === item.id"></a-icon>
          </span>
          <a-list-item-meta>
            <span slot="title">{{ item.nickname }}</span>
            <a-avatar slot="avatar" :src="item.avatar" class="avatar-bg">{{ item.nickname[0] }}</a-avatar>
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </div>
    <!-- <div class="footer">
      <a-button type="primary" block @click.stop="handleSubmit">确定</a-button>
    </div> -->
  </div>
</template>
<script>
import infiniteScroll from 'vue-infinite-scroll';
export default {
  directives: { infiniteScroll },
  props: {
    userList: {
      type: Array,
      default() {
        return [];
      }
    },
    loading: { type: Boolean, default: true },
    total: { type: Number, default: 0 }
  },
  data() {
    return {
      busy: false,
      defaultSelect: 8,
      listTemp: {}
    };
  },
  methods: {
    handleInfiniteOnLoad() {
      if (this.total > this.userList.length) {
        this.$emit('loadMore');
      } else {
        this.$message.info('已加载全部数据');
      }
    },
    handleSubmit() {
      this.$emit('choose', this.listTemp);
    },
    handleChoose(item) {
      // 列表项点击
      this.listTemp = { ...item };
      this.handleSubmit();
    }
  }
};
</script>
<style lang="less" scoped>
.user-list {
  background: #fff;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  padding: 12px 0;
  width: 250px;
  height: 282px;
  border-radius: 4px;
  position: relative;
  overflow-y: auto;
  .member-list-item {
    padding: 12px;
    cursor: pointer;
    border-bottom: none;
    .ant-list-item-meta {
      align-items: center;
    }
    &.owner {
      cursor: not-allowed;
    }
    &:hover {
      background-color: #f5f5f5;
    }
  }
}
</style>
